const {
    clickableCollapsibleDivPresenter
} = require('gui');

module.exports = function collapsibleRegionPresenter(headerString, optionalOptions = {}) {
    const c = {};
    var innerPresenter = clickableCollapsibleDivPresenter();

    c.activate = function(region) {
        innerPresenter.activate(region);
        innerPresenter.headerRegion().innerText = headerString;
        innerPresenter.headerRegion().classList.add('collapsibleRegionPresenter');
        innerPresenter.subscribeCollapse(onCollapse);
        innerPresenter.subscribeExpand(onExpand);
        if(window.innerWidth < 992 || optionalOptions.collapsed) {
            innerPresenter.collapse();
            onCollapse();
        } else {
            innerPresenter.expand();
            onExpand();
        }
    };

    c.expand = function() {
        innerPresenter.expand();
    };

    c.collapse = function() {
        innerPresenter.collapse();
    };

    function onCollapse() {
        innerPresenter.headerRegion().classList.add('collapsibleRegionPresenter-collapsed');
        innerPresenter.headerRegion().classList.remove('collapsibleRegionPresenter-expanded');
    }

    function onExpand() {
        innerPresenter.headerRegion().classList.remove('collapsibleRegionPresenter-collapsed');
        innerPresenter.headerRegion().classList.add('collapsibleRegionPresenter-expanded');
    }

    c.contentRegion = innerPresenter.contentRegion;

    c.deactivate = function() {
        innerPresenter.unsubscribeExpand(onCollapse);
        innerPresenter.unsubscribeCollapse(onExpand);
        innerPresenter.headerRegion().classList.remove('collapsibleRegionPresenter');
        innerPresenter.deactivate();
    };

    return c;
}
